import deviceService from '@/api/device'
import { DEVICE_SET, DEVICE_ROOM_SET, DEVICE_MOVE_RIGHT, DEVICE_MOVE_LEFT, DEVICE_REMOVE, CLEAR_ALL } from '../types'

export default {
  namespaced: true,
  state: {
    devices: [],
    roomDevices: []
  },
  getters: {
    roomBusyPerct (state, getters) {
      if (state.deviceStatus === null) {
        return 0
      } else {
        return (getters.roomBusy) * 100 / getters.totalRooms
      }
    }
  },
  mutations: {
    [DEVICE_SET] (state, devices) {
      state.devices = devices
    },
    [DEVICE_ROOM_SET] (state, roomDevices) {
      state.roomDevices = roomDevices
    },
    [DEVICE_MOVE_RIGHT] (state, index) {
      state.roomDevices.push(state.devices[index])
      state.devices.splice(index, 1)
    },
    [DEVICE_MOVE_LEFT] (state, index) {
      state.devices.push(state.roomDevices[index])
      state.roomDevices.splice(index, 1)
    },
    [DEVICE_REMOVE] (state, index) {
      state.devices.splice(index, 1)
    },
    [CLEAR_ALL] (state) {
      state.devicesStatus = []
      state.devices = []
      state.roomDevices = []
    }
  },
  actions: {
    getDevicesList ({commit}) {
      return new Promise((resolve, reject) => {
        deviceService.getDevices().then((response) => {
          commit(DEVICE_SET, response.data)
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getDevicesByRoom ({commit, state}, obj) {
      return new Promise((resolve, reject) => {
        deviceService.getDevicesByRoom(obj.locationId, obj.roomId).then((response) => {
          commit(DEVICE_ROOM_SET, response.data)
          for (let i = 0; i < state.devices.length; i++) {
            for (let j = 0; j < state.roomDevices.length; j++) {
              if (state.devices[i].identifier === state.roomDevices[j].identifier) {
                commit(DEVICE_REMOVE, i)
                i--
                break
              }
            }
          }
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    addDevice ({commit}, index) {
      commit(DEVICE_MOVE_RIGHT, index)
    },
    removeDevice ({commit}, index) {
      commit(DEVICE_MOVE_LEFT, index)
    },
    saveDeviceByRoom ({ state }, obj) {
      return deviceService.saveDeviceByRoom(obj.locationId, obj.roomId, state.roomDevices)
    },
    clearData ({ commit }) {
      commit(CLEAR_ALL)
    },
    // eslint-disable-next-line no-empty-pattern
    saveDevice ({}, obj) {
      return deviceService.saveDevice(obj)
    },
    // eslint-disable-next-line no-empty-pattern
    deleteDevice ({}, id) {
      return deviceService.deleteDevice(id)
    }
  }
}
